var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import * as React from 'react';
import { NaviError, Status, isSegmentSteady } from 'navi';
import { NavContext } from './NavContext';
import { NavLoadingContext } from './NavLoading';
export var NavSegment = function Consume(props) {
  return React.createElement(NavContext.Consumer, null, function (context) {
    return React.createElement(NavLoadingContext.Consumer, null, function (navLoadingContext) {
      return React.createElement(InnerConsumeSegment, __assign({}, props, {
        context: context,
        navLoadingContext: navLoadingContext
      }));
    });
  });
};
NavSegment.defaultProps = {
  isReady: function isReady(segment) {
    return isSegmentSteady(segment);
  }
};

var InnerConsumeSegment =
/** @class */
function (_super) {
  __extends(InnerConsumeSegment, _super);

  function InnerConsumeSegment(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    return _this;
  }

  InnerConsumeSegment.getDerivedStateFromProps = function (props, state) {
    var unconsumedSegments = props.context.unconsumedSegments || props.context.route.segments;
    var lastReady = state.lastReady; // Bail if nothing has changed

    if (lastReady && lastReady.context === props.context) {
      return null;
    }

    var isReady = props.isReady(unconsumedSegments[0]);

    if (isReady) {
      var index = props.where ? unconsumedSegments.findIndex(props.where) : 0;
      var errorSearchSegments = index === -1 ? unconsumedSegments : unconsumedSegments.slice(0, index + 1);
      var errorSegment = errorSearchSegments.find(function (segment) {
        return segment.status === Status.Error;
      });

      if (errorSegment) {
        return {
          error: errorSegment.error || new Error("Unknown routing error")
        };
      }

      if (index === -1) {
        return {
          error: new MissingSegment(props.context)
        };
      }

      var consumedSegments = unconsumedSegments.slice(0, index + 1);
      var segment = unconsumedSegments[index];
      lastReady = {
        segment: segment,
        consumedSegments: consumedSegments,
        context: props.context,
        childContext: __assign({}, props.context, {
          unconsumedSegments: unconsumedSegments.slice(index + 1)
        })
      };
    }

    return {
      lastReady: lastReady,
      isReady: isReady
    };
  };

  InnerConsumeSegment.prototype.componentDidUpdate = function (prevProps, prevState) {
    this.handleUpdate(prevState);
  };

  InnerConsumeSegment.prototype.componentDidMount = function () {
    this.handleUpdate();
  };

  InnerConsumeSegment.prototype.handleUpdate = function (prevState) {
    if (this.state.lastReady && (!prevState || !prevState.lastReady || prevState.lastReady.context !== this.state.lastReady.context)) {
      this.state.lastReady.context.onRendered();
    }

    if (!this.state.isReady && !this.props.navLoadingContext.isLoading) {
      this.props.navLoadingContext.setLoading(true);
    } else if (this.state.isReady && this.props.navLoadingContext.isLoading) {
      this.props.navLoadingContext.setLoading(false);
    }
  };

  InnerConsumeSegment.prototype.componentWillUnmount = function () {
    if (this.showBusyIndicatorTimeout) {
      window.clearTimeout(this.showBusyIndicatorTimeout);
      delete this.showBusyIndicatorTimeout;
    }
  };

  InnerConsumeSegment.prototype.render = function () {
    if (this.state.error) {
      throw this.state.error;
    }

    var _a = this.props.context,
        history = _a.history,
        router = _a.router,
        route = _a.route;
    var output = this.state.lastReady ? {
      segment: this.state.lastReady.segment,
      consumedSegments: this.state.lastReady.consumedSegments,
      unconsumedSegments: this.state.lastReady.childContext.unconsumedSegments,
      route: this.state.lastReady.childContext.route,
      history: history,
      router: router
    } : {
      segment: undefined,
      consumedSegments: [],
      unconsumedSegments: [],
      route: route,
      history: history,
      router: router
    };
    var render = this.props.children;

    if (!render) {
      throw new Error("<NavSegment> requires that you specify a `children` function.");
    } else if (typeof render !== "function") {
      throw new Error("<NavSegment> expects its children or \"segment.content\" to be a function, but instead received \"" + render + "\".");
    }

    return (
      /*
        As this segment handles any Loading element up the tree, we need
        to hide it from any child segments.
      */
      React.createElement(NavLoadingContext.Provider, {
        value: {
          isLoading: false,
          setLoading: noop
        }
      }, React.createElement(NavContext.Provider, {
        value: this.state.lastReady ? this.state.lastReady.childContext : this.props.context
      }, render(output)))
    );
  };

  return InnerConsumeSegment;
}(React.Component);

function noop() {}

var MissingSegment =
/** @class */
function (_super) {
  __extends(MissingSegment, _super);

  function MissingSegment(context) {
    var _this = _super.call(this, "A <NavSegment> component attempted to use a segment that couldn't be found.") || this;

    _this.context = context;
    return _this;
  }

  return MissingSegment;
}(NaviError);

export { MissingSegment };